import type { UserDto } from '~/services/api/generated'
import { normalizeIdentity } from '~/utils/normalizeIdentity'
import { useLogger } from '~/composables/useLogger'

// The vendor module writes the raw `/api/user` response (the Laravel
// `{ data }` envelope) straight into sanctum state before firing these
// hooks. This is the only place that state is validated: after any of the
// three hooks below, the sanctum user ref holds a validated UserDto or
// null, never the raw envelope. Setting `user.value` here does not itself
// call a hook, so this cannot recurse.
export default defineNuxtPlugin(() => {
  const logger = useLogger('identityBoundary')
  const user = useSanctumUser<UserDto>()

  const enforceIdentityBoundary = () => {
    user.value = normalizeIdentity(user.value, logger)
  }

  const nuxtApp = useNuxtApp()
  nuxtApp.hook('sanctum:init', enforceIdentityBoundary)
  nuxtApp.hook('sanctum:login', enforceIdentityBoundary)
  nuxtApp.hook('sanctum:refresh', enforceIdentityBoundary)
})
